import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import styles from './PlayerNowPlaying.styles';
import classNames from 'classnames';
import NowPlayingImage from './NowPlayingImage';
import { isTouch } from 'util/device';

import Query from 'components/Query';
import AirTime from 'components/Tiles/ShowTile/AirTime';
import useNowPlaying from './useNowPlaying';
import logger from 'util/logger';

const PlayerNowPlaying = ({
  classes,
  slug,
  additionalFetchContentTypeId,
  contentTypeId,
  imageUrl,
  logo,
  brandColor,
  title: titleInitial,
  subtitle: subtitleInitial,
}) => {
  const [{ title, subtitle }, setInfo] = useState({});

  useEffect(() => {
    setInfo({ title: titleInitial, subtitle: subtitleInitial });
  }, [slug]);

  const onPlayouts = ([{ title: playoutTitle, artistName }] = [{}]) => {
    setInfo({ title: titleInitial, subtitle: `${artistName} - ${playoutTitle}` });
  };

  const onShow = ({ title: showTitle, ...show }) => {
    setInfo({
      title: showTitle,
      subtitle: getOnAirInfo(show),
    });
  };

  const onError = (e) => {
    logger.error('error', e);
  };

  useNowPlaying({ slug, isDisabled: contentTypeId !== 'station', onPlayouts, onShow, onError });

  const getOnAirInfo = ({ startTime, endTime, broadcastStartDate, broadcastEndDate }) => {
    const hasOnAirTime = startTime && endTime;
    const hasOnAirBroadcastTime = broadcastStartDate && broadcastEndDate;

    if (hasOnAirTime) {
      return `${startTime} - ${endTime}`;
    }
    if (!hasOnAirTime && hasOnAirBroadcastTime) {
      return <AirTime timeStart={broadcastStartDate} timeEnd={broadcastEndDate} />;
    }
    return null;
  };

  return (
    <Query slug={slug} contentTypeId={additionalFetchContentTypeId}>
      {({ data }) => {
        const { schedules } = data || {};

        let nowTitle = title;
        let nowSubtitle = subtitle;
        if (schedules && schedules[0]) {
          nowTitle = schedules[0].title;
          nowSubtitle = getOnAirInfo(schedules[0]);
        }

        return (
          <div className={classNames(classes.container, { [classes.containerMobile]: isTouch })}>
            <NowPlayingImage imageUrl={imageUrl} backgroundColor={brandColor} logo={logo} />
            <div
              className={classNames(classes.infoArea, {
                [classes.hideDesktopSmall]: !isTouch,
                [classes.infoAreaMobile]: isTouch,
              })}
            >
              <span className={classes.title}>{nowTitle}</span>
              <span className={classes.subtitle}>{nowSubtitle}</span>
            </div>
          </div>
        );
      }}
    </Query>
  );
};

PlayerNowPlaying.propTypes = {
  classes: PropTypes.object.isRequired,
  slug: PropTypes.string,
  contentTypeId: PropTypes.string,
  additionalFetchContentTypeId: PropTypes.string,

  imageUrl: PropTypes.string,
  logo: PropTypes.string,
  brandColor: PropTypes.string,

  title: PropTypes.string,
  subtitle: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  broadcastStartDate: PropTypes.string,
  broadcastEndDate: PropTypes.string,
};

PlayerNowPlaying.defaultProps = {
  slug: null,
  contentTypeId: null,
  additionalFetchContentTypeId: null,

  imageUrl: null,
  logo: null,
  brandColor: null,

  title: null,
  subtitle: null,
};

export default injectStyles(styles)(PlayerNowPlaying);
